import Menu from './Compartido/Menu.jsx';
import DatosReserva from './Reserva/DatosReserva.jsx';
import Footer from './Compartido/Footer.jsx';

const Reserva = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.websgrupo}
                ruta={props.ruta}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
            />
            <DatosReserva
                propiedad={props.propiedad}
                precios={props.precios}
                llegada={props.llegada}
                salida={props.salida}
                difdias={props.difdias}
                adultos={props.adultos}
                ninos={props.ninos}
                bebes={props.bebes}
                lang={props.lang}
                ruta={props.ruta}
                config={props.config}
                tpvs={props.tpvs}
                paypal={props.paypal}
                transferencia={props.transferencia}
                stripe={props.stripes}
                paycomet={props.paycomet}
                moneda={props.moneda}
                numpropiedades={props.numpropiedades}
                websgrupo={props.websgrupo}
                tarifa={props.tarifa}
                paises={props.paises}
            />

            <Footer
                datos={props.websgrupo}
                lang={props.lang}
                ruta={props.ruta}
                logos_pie={props.logos_pie}
                websgrupo={props.websgrupo}
            />
        </main>
    );
}

export default Reserva;
